import React from 'react'

function TextInput({
    name,
    label,
    required,
    placeholder,
    value,
    onChange,
    onBlur,
    error,
    disabled,
    infoText,
}) {
    return (
        <div className='flex flex-col space-y-2'>
            <label
                for={name}
                className='font-bold flex text-sm md:text-base'
            >
                <p>{label}</p>
                {required && (
                    <span className='text-app-brown'>*</span>
                )}
            </label>
            <input
                id={name}
                className='border border-indigo-600 rounded-lg bg-transparent px-3 py-2 text-sm md:text-base focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500'
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                placeholder={placeholder}
                disabled={disabled}
                autoComplete='off'
            />
            <p className='text-xs text-app-grey'>{infoText}</p>
            {error && (
                <p className='text-xs text-app-brown'>{error}</p>
            )}
        </div>
    )
}

export default TextInput